export default {
	countryList: [
		{
			cnName: '香港',
			enName: 'HongKong',
			code: '852',
			geo: '中国香港',
			price: '0',
			sort: 'H'
		},
		{
			cnName: '澳门',
			enName: 'Macau',
			code: '853',
			geo: '中国澳门',
			price: '0',
			sort: 'A'
		},
		{
			cnName: '台湾',
			enName: 'Taiwan',
			code: '886',
			geo: '中国台湾',
			price: '0',
			sort: 'T'
		},
		{
			cnName: '澳大利亚',
			enName: 'Australia',
			code: 'AU',
			geo: '其他亚洲',
			price: '200',
			sort: 'A'
		},
		{
			cnName: '奥地利',
			enName: 'Austria',
			enFullName: 'the Republic of Austria',
			code: 'AT',
			geo: '欧洲',
			price: '400',
			sort: 'A'
		},
		{
			cnName: '比利时',
			enName: 'Belgium',
			enFullName: 'the Kingdom of Belgium',
			code: 'BE',
			geo: '欧洲',
			price: '400',
			sort: 'B'
		},
		{
			cnName: '文莱',
			enName: 'Brunei Darussalam',
			code: 'BN',
			geo: '其他亚洲',
			price: '200',
			sort: 'B'
		},
		{
			cnName: '白俄罗斯',
			enName: 'Belarus',
			enFullName: 'the Republic of Belarus',
			code: 'BY',
			geo: '欧洲',
			price: '400',
			sort: 'B'
		},
		{
			cnName: '保加利亚',
			enName: 'Bulgaria',
			enFullName: 'the Republic of Bulgaria',
			code: 'BG',
			geo: '欧洲',
			price: '400',
			sort: 'B'
		},
		{
			cnName: '巴西',
			enName: 'Brazil',
			enFullName: 'the Federative Republic of Brazil',
			code: 'BR',
			geo: '美洲',
			price: '400',
			sort: 'B'
		},
		{
			cnName: '孟加拉国',
			enName: 'Bangladesh',
			enFullName: "the People's Republic of Bangladesh",
			code: 'BD',
			geo: '其他亚洲',
			price: '200',
			sort: 'B'
		},
		{
			cnName: '柬埔寨',
			enName: 'Cambodia',
			enFullName: 'the Kingdom of Cambodia',
			code: 'KH',
			geo: '其他亚洲',
			price: '200',
			sort: 'C'
		},
		{
			cnName: '加拿大',
			enName: 'Canada',
			code: 'CA',
			geo: '美洲',
			price: '400',
			sort: 'C'
		},
		{
			cnName: '捷克',
			enName: 'Czech Republic',
			enFullName: 'the Czech Republic',
			code: 'CZ',
			geo: '欧洲',
			price: '400',
			sort: 'C'
		},
		{
			cnName: '克罗地亚',
			enName: 'Croatia',
			enFullName: 'the Republic of Croatia',
			code: 'HR',
			geo: '欧洲',
			price: '500',
			sort: 'C'
		},
		{
			cnName: '智利',
			enName: 'Chile',
			enFullName: 'the Republic of Chile',
			code: 'CL',
			geo: '美洲',
			price: '400',
			sort: 'C'
		},
		{
			cnName: '塞浦路斯',
			enName: 'Cyprus',
			enFullName: 'the Republic of Cyprus',
			code: 'CY',
			geo: '欧洲',
			price: '500',
			sort: 'C'
		},
		{
			cnName: '丹麦',
			enName: 'Denmark',
			enFullName: 'the Kingdom of Denmark',
			code: 'DK',
			geo: '欧洲',
			price: '400',
			sort: 'D'
		},
		{
			cnName: '爱沙尼亚',
			enName: 'Estonia',
			enFullName: 'the Republic of Estonia',
			code: 'EE',
			geo: '欧洲',
			price: '500',
			sort: 'E'
		},
		{
			cnName: '法国',
			enName: 'France',
			enFullName: 'the French Republic',
			code: 'FR',
			geo: '欧洲',
			price: '400',
			sort: 'F'
		},
		{
			cnName: '芬兰',
			enName: 'Finland',
			enFullName: 'the Republic of Finland',
			code: 'FI',
			geo: '欧洲',
			price: '400',
			sort: 'F'
		},
		{
			cnName: '德国',
			enName: 'Germany',
			enFullName: 'he Federal Republic of Germany',
			code: 'DE',
			geo: '欧洲',
			price: '400',
			sort: 'G'
		},
		{
			cnName: '希腊',
			enName: 'Greece',
			enFullName: 'the Hellenic Republic',
			code: 'GR',
			geo: '欧洲',
			price: '400',
			sort: 'G'
		},
		{
			cnName: '匈牙利',
			enName: 'Hungary',
			enFullName: 'the Republic of Hungary',
			code: 'HU',
			geo: '欧洲',
			price: '400',
			sort: 'H'
		},
		{
			cnName: '意大利',
			enName: 'Italy',
			enFullName: 'the Republic of Italy',
			code: 'IT',
			geo: '欧洲',
			price: '400',
			sort: 'I'
		},
		{
			cnName: '印度',
			enName: 'India',
			enFullName: 'the Republic of India',
			code: 'IN',
			geo: '其他亚洲',
			price: '500',
			sort: 'I'
		},
		{
			cnName: '印度尼西亚',
			enName: 'Indonesia',
			enFullName: 'the Republic of Indonesia',
			code: 'ID',
			geo: '其他亚洲',
			price: '200',
			sort: 'I'
		},
		{
			cnName: '爱尔兰',
			enName: 'Ireland',
			code: 'IE',
			geo: '欧洲',
			price: '400',
			sort: 'I'
		},
		{
			cnName: '日本',
			enName: 'Japan',
			code: 'JP',
			geo: '其他亚洲',
			price: '200',
			sort: 'J'
		},
		{
			cnName: '韩国',
			enName: 'Korea',
			enFullName: 'the Republic of Korea',
			code: 'KR',
			geo: '其他亚洲',
			price: '200',
			sort: 'K'
		},
		{
			cnName: '拉脱维亚',
			enName: 'Latvia',
			enFullName: 'the Republic of Latvia',
			code: 'LV',
			geo: '欧洲',
			price: '500',
			sort: 'L'
		},
		{
			cnName: '立陶宛',
			enName: 'Lithuania',
			enFullName: 'the Republic of Lithuania',
			code: 'LT',
			geo: '欧洲',
			price: '500',
			sort: 'L'
		},
		{
			cnName: '卢森堡',
			enName: 'Luxembourg',
			enFullName: 'the Grand Duchy of Luxembourg',
			code: 'LU',
			geo: '欧洲',
			price: '400',
			sort: 'L'
		},
		{
			cnName: '马来西亚',
			enName: 'Malaysia',
			code: 'MY',
			geo: '其他亚洲',
			price: '200',
			sort: 'M'
		},
		{
			cnName: '马耳他',
			enName: 'Malta',
			enFullName: 'the Republic of Malta',
			code: 'MT',
			geo: '欧洲',
			price: '500',
			sort: 'M'
		},
		{
			cnName: '蒙古',
			enName: 'Mongolia',
			code: 'MN',
			geo: '其他亚洲',
			price: '500',
			sort: 'M'
		},
		{
			cnName: '墨西哥',
			enName: 'Mexico',
			enFullName: 'the United Mexican States',
			code: 'MX',
			geo: '美洲',
			price: '400',
			sort: 'M'
		},
		{
			cnName: '缅甸',
			enName: 'Myanmar',
			enFullName: 'the Union of Myanmar',
			code: 'MM',
			geo: '其他亚洲',
			price: '200',
			sort: 'M'
		},
		{
			cnName: '荷兰',
			enName: 'Netherlands',
			enFullName: 'the Kingdom of the Netherlands',
			code: 'NL',
			geo: '欧洲',
			price: '400',
			sort: 'N'
		},
		{
			cnName: '挪威',
			enName: 'Norway',
			enFullName: 'the Kingdom of Norway',
			code: 'NO',
			geo: '欧洲',
			price: '400',
			sort: 'N'
		},
		{
			cnName: '新西兰',
			enName: 'New Zealand',
			code: 'NZ',
			geo: '其他亚洲',
			price: '200',
			sort: 'N'
		},
		{
			cnName: '尼泊尔',
			enName: 'Nepal',
			code: 'NP',
			geo: '其他亚洲',
			price: '200',
			sort: 'N'
		},
		{
			cnName: '波兰',
			enName: 'Poland',
			enFullName: 'the Republic of Poland',
			code: 'PL',
			geo: '欧洲',
			price: '400',
			sort: 'P'
		},
		{
			cnName: '巴基斯坦',
			enName: 'Pakistan',
			enFullName: 'the Islamic Republic of Pakistan',
			code: 'PK',
			geo: '其他亚洲',
			price: '200',
			sort: 'P'
		},
		{
			cnName: '菲律宾',
			enName: 'Philippines',
			enFullName: 'the Republic of the Philippines',
			code: 'PH',
			geo: '其他亚洲',
			price: '200',
			sort: 'P'
		},
		{
			cnName: '葡萄牙',
			enName: 'Portugal',
			enFullName: 'the Portuguese Republic',
			code: 'PT',
			geo: '欧洲',
			price: '400',
			sort: 'P'
		},
		{
			cnName: '俄罗斯',
			enName: 'Russian Federation',
			enFullName: 'the Russian Federation',
			code: 'RU',
			geo: '欧洲',
			price: '400',
			sort: 'R'
		},
		{
			cnName: '罗马尼亚',
			enName: 'Romania',
			code: 'RO',
			geo: '欧洲',
			price: '400',
			sort: 'R'
		},
		{
			cnName: '瑞典',
			enName: 'Sweden',
			enFullName: 'the Kingdom of Sweden',
			code: 'SE',
			geo: '欧洲',
			price: '400',
			sort: 'S'
		},
		{
			cnName: '斯里兰卡',
			enName: 'Sri Lanka',
			enFullName: 'the Democratic Socialist Republic of Sri Lanka',
			code: 'LK',
			geo: '其他亚洲',
			price: '200',
			sort: 'S'
		},
		{
			cnName: '斯洛文尼亚',
			enName: 'Slovenia',
			enFullName: 'the Republic of Slovenia',
			code: 'SI',
			geo: '欧洲',
			price: '400',
			sort: 'S'
		},
		{
			cnName: '西班牙',
			enName: 'Spain',
			enFullName: 'the Kingdom of Spain',
			code: 'ES',
			geo: '欧洲',
			price: '400',
			sort: 'S'
		},
		{
			cnName: '新加坡',
			enName: 'Singapore',
			enFullName: 'the Republic of Singapore',
			code: 'SG',
			geo: '其他亚洲',
			price: '200',
			sort: 'S'
		},
		{
			cnName: '瑞士',
			enName: 'Switzerland',
			enFullName: 'the Swiss Confederation',
			code: 'CH',
			geo: '欧洲',
			price: '400',
			sort: 'S'
		},
		{
			cnName: '斯洛伐克',
			enName: 'Slovakia',
			enFullName: 'the Slovak Republic',
			code: 'SK',
			geo: '欧洲',
			price: '400',
			sort: 'S'
		},
		{
			cnName: '沙特阿拉伯',
			enName: 'Saudi Arabia',
			enFullName: 'the Kingdom of Saudi Arabia',
			code: 'SA',
			geo: '其他亚洲',
			price: '200',
			sort: 'S'
		},
		{
			cnName: '泰国',
			enName: 'Thailand',
			enFullName: 'the Kingdom of Thailand',
			code: 'TH',
			geo: '其他亚洲',
			price: '200',
			sort: 'T'
		},
		{
			cnName: '阿联酋',
			enName: 'United Arab Emirates',
			enFullName: 'the United Arab Emirates',
			code: 'AE',
			geo: '其他亚洲',
			price: '500',
			sort: 'U'
		},
		{
			cnName: '英国',
			enName: 'United Kingdom',
			enFullName:
				'the United Kingdom of Great Britain and Northern Ireland',
			code: 'GB',
			geo: '欧洲',
			price: '400',
			sort: 'U'
		},
		{
			cnName: '美国',
			enName: 'United States of America',
			enFullName: 'the United States of America',
			code: 'US',
			geo: '美洲',
			price: '400',
			sort: 'U'
		},
		{
			cnName: '越南',
			enName: 'Viet Nam',
			enFullName: 'the Socialist Republic of Viet Nam',
			code: 'VN',
			geo: '其他亚洲',
			price: '200',
			sort: 'V'
		},
		{
			cnName: '坦桑尼亚',
			enName: 'Tanzania',
			enFullName: 'The United Republic of Tanzania',
			code: 'TZ',
			geo: '非洲',
			price: '',
			sort: 'T'
		},
		{
			cnName: '尼日利亚',
			enName: 'Nigeria',
			enFullName: 'Federal Republic of Nigeria',
			code: 'NG',
			geo: '非洲',
			price: '',
			sort: 'N'
		},
		{
			cnName: '刚果民主共和国',
			enName: 'Congo',
			enFullName: 'The Democratic Republic of the Congo',
			code: 'CD',
			geo: '非洲',
			price: '',
			sort: 'C'
		},
		{
			cnName: '乌干达',
			enName: 'Uganda',
			enFullName: 'The Republic of Uganda',
			code: 'UG',
			geo: '非洲',
			price: '',
			sort: 'U'
		},
		{
			cnName: '喀麦隆',
			enName: 'Cameroon',
			enFullName: 'The Republic of Cameroon',
			code: 'CM',
			geo: '非洲',
			price: '',
			sort: 'C'
		},
		{
			cnName: '马里',
			enName: 'Mali',
			enFullName: 'The Republic of Mali',
			code: 'ML',
			geo: '非洲',
			price: '',
			sort: 'M'
		},
		{
			cnName: '多哥',
			enName: 'Togo',
			enFullName: 'The Republic of Togo',
			code: 'TG',
			geo: '非洲',
			price: '',
			sort: 'T'
		},
		{
			cnName: '加纳',
			enName: 'Ghana',
			enFullName: 'The Republic of Ghana',
			code: 'GH',
			geo: '非洲',
			price: '',
			sort: 'G'
		},
		{
			cnName: '刚果',
			enName: 'Congo',
			enFullName: 'Congo',
			code: 'CG',
			geo: '',
			price: '',
			sort: 'G'
		},
		{
			cnName: '埃塞俄比亚',
			enName: 'Ethiopia',
			enFullName: 'Ethiopia',
			code: 'ET',
			geo: '',
			price: '',
			sort: 'G'
		},
		{
			cnName: '波利维亚',
			enName: 'Bolivia',
			enFullName: 'Bolivia',
			code: 'BO',
			geo: '',
			price: '',
			sort: 'G'
		},
		{
			cnName: '哥伦比亚',
			enName: 'Colombia',
			enFullName: 'Colombia',
			code: 'CO',
			geo: '',
			price: '',
			sort: 'G'
		},
		{
			cnName: '厄瓜多尔',
			enName: 'Ecuador',
			enFullName: 'Ecuador',
			code: 'EC',
			geo: '',
			price: '',
			sort: 'G'
		},
		{
			cnName: '秘鲁',
			enName: 'Peru',
			enFullName: 'Peru',
			code: 'PE',
			geo: '',
			price: '',
			sort: 'G'
		},
		{
			cnName: '苏里南',
			enName: 'Suriname',
			enFullName: 'Suriname',
			code: 'SR',
			geo: '',
			price: '',
			sort: 'G'
		},
		{
			cnName: '乌拉圭',
			enName: 'Uruguay',
			enFullName: 'Uruguay',
			code: 'UY',
			geo: '',
			price: '',
			sort: 'G'
		},
		{
			cnName: '委内瑞拉',
			enName: 'Venezuela',
			enFullName: 'Venezuela',
			code: 'VE',
			geo: '',
			price: '',
			sort: 'G'
		},
		{
			cnName: '阿根廷',
			enName: 'Argentina',
			enFullName: 'Argentina',
			code: 'AR',
			geo: '',
			price: '',
			sort: 'G'
		},
		{
			cnName: '德国',
			enName: 'Germany',
			enFullName: 'Germany',
			code: 'DE',
			geo: '',
			price: '',
			sort: 'G'
		},
		{
			cnName: '法国',
			enName: 'France',
			enFullName: 'France',
			code: 'FR',
			geo: '',
			price: '',
			sort: 'G'
		},
		{
			cnName: '西班牙',
			enName: 'Spain',
			enFullName: 'Spain',
			code: 'ES',
			geo: '',
			price: '',
			sort: 'G'
		},
		{
			cnName: '意大利',
			enName: 'Italy',
			enFullName: 'Italy',
			code: 'IT',
			geo: '',
			price: '',
			sort: 'G'
		},
		{
			cnName: '英国',
			enName: 'United Kingdom',
			enFullName: 'United Kingdom',
			code: 'GB',
			geo: '',
			price: '',
			sort: 'G'
		},
		{
			cnName: '比利时',
			enName: 'Belgium',
			enFullName: 'Belgium',
			code: 'BE',
			geo: '',
			price: '',
			sort: 'G'
		},
		{
			cnName: '奥地利',
			enName: 'Austria',
			enFullName: 'Austria',
			code: 'AT',
			geo: '',
			price: '',
			sort: 'G'
		},
		{
			cnName: '爱尔兰',
			enName: 'Ireland',
			enFullName: 'Ireland',
			code: 'IE',
			geo: '',
			price: '',
			sort: 'G'
		},
		{
			cnName: '匈牙利',
			enName: 'Hungary',
			enFullName: 'Hungary',
			code: 'HU',
			geo: '',
			price: '',
			sort: 'G'
		},
		{
			cnName: '葡萄牙',
			enName: 'Portugal',
			enFullName: 'Portugal',
			code: 'PT',
			geo: '',
			price: '',
			sort: 'G'
		},
		{
			cnName: '荷兰',
			enName: 'Netherlands',
			enFullName: 'Netherlands',
			code: 'NL',
			geo: '',
			price: '',
			sort: 'G'
		},
		{
			cnName: '波兰',
			enName: 'Poland',
			enFullName: 'Poland',
			code: 'PL',
			geo: '',
			price: '',
			sort: 'G'
		},
		{
			cnName: '丹麦',
			enName: 'Denmark',
			enFullName: 'Denmark',
			code: 'DK',
			geo: '',
			price: '',
			sort: 'G'
		},
		{
			cnName: '捷克',
			enName: 'Czech Republic',
			enFullName: 'Czech Republic',
			code: 'CZ',
			geo: '',
			price: '',
			sort: 'G'
		},
		{
			cnName: '克罗地亚',
			enName: 'Croatia',
			enFullName: 'Croatia',
			code: 'HR',
			geo: '',
			price: '',
			sort: 'G'
		},
		{
			cnName: '瑞典',
			enName: 'Sweden',
			enFullName: 'Sweden',
			code: 'SE',
			geo: '',
			price: '',
			sort: 'G'
		},
		{
			cnName: '希腊',
			enName: 'Greece',
			enFullName: 'Greece',
			code: 'GR',
			geo: '',
			price: '',
			sort: 'G'
		},
		{
			cnName: '保加利亚',
			enName: 'Bulgaria',
			enFullName: 'Bulgaria',
			code: 'BG',
			geo: '',
			price: '',
			sort: 'G'
		},
		{
			cnName: '卢森堡',
			enName: 'Luxembourg',
			enFullName: 'Luxembourg',
			code: 'LU',
			geo: '',
			price: '',
			sort: 'G'
		},
		{
			cnName: '爱沙尼亚',
			enName: 'Estonia',
			enFullName: 'Estonia',
			code: 'EE',
			geo: '',
			price: '',
			sort: 'G'
		},
		{
			cnName: '芬兰',
			enName: 'Finland',
			enFullName: 'Finland',
			code: 'FI',
			geo: '',
			price: '',
			sort: 'G'
		},
		{
			cnName: '立陶宛',
			enName: 'Lithuania',
			enFullName: 'Lithuania',
			code: 'LT',
			geo: '',
			price: '',
			sort: 'G'
		},
		{
			cnName: '斯洛文尼亚',
			enName: 'Slovenia',
			enFullName: 'Slovenia',
			code: 'SI',
			geo: '',
			price: '',
			sort: 'G'
		},
		{
			cnName: '斯洛伐克',
			enName: 'Slovakia',
			enFullName: 'Slovakia',
			code: 'SK',
			geo: '',
			price: '',
			sort: 'G'
		},
		{
			cnName: '拉脱维亚',
			enName: 'Latvia',
			enFullName: 'Latvia',
			code: 'LV',
			geo: '',
			price: '',
			sort: 'G'
		},
		{
			cnName: '罗马尼亚',
			enName: 'Romania',
			enFullName: 'Romania',
			code: 'RO',
			geo: '',
			price: '',
			sort: 'G'
		},
		{
			cnName: '刚果',
			enName: 'Congo',
			enFullName: 'Congo',
			code: 'CG',
			geo: '',
			price: '',
			sort: 'G'
		},
		{
			cnName: '刚果民主共和国',
			enName: 'Dem. Rep. of Congo',
			enFullName: 'Dem. Rep. of Congo',
			code: 'CD',
			geo: '',
			price: '',
			sort: 'G'
		},
		{
			cnName: '加纳',
			enName: 'Ghana',
			enFullName: 'Ghana',
			code: 'GH',
			geo: '',
			price: '',
			sort: 'G'
		},
		{
			cnName: '肯尼亚',
			enName: 'Kenya',
			enFullName: 'Kenya',
			code: 'KE',
			geo: '',
			price: '',
			sort: 'G'
		},
		{
			cnName: '马里',
			enName: 'Mali',
			enFullName: 'Mali',
			code: 'ML',
			geo: '',
			price: '',
			sort: 'G'
		},
		{
			cnName: '摩洛哥',
			enName: 'Morocco',
			enFullName: 'Morocco',
			code: 'MA',
			geo: '',
			price: '',
			sort: 'G'
		},
		{
			cnName: '尼日利亚',
			enName: 'Nigeria',
			enFullName: 'Nigeria',
			code: 'NG',
			geo: '',
			price: '',
			sort: 'G'
		},
		{
			cnName: '卢旺达',
			enName: 'Rwanda',
			enFullName: 'Rwanda',
			code: 'RW',
			geo: '',
			price: '',
			sort: 'G'
		},
		{
			cnName: '坦桑尼亚',
			enName: 'Tanzania (United Rep.)',
			enFullName: 'Tanzania (United Rep.)',
			code: 'TZ',
			geo: '',
			price: '',
			sort: 'G'
		},
		{
			cnName: '老挝',
			enName: "Lao People's Dem. Rep.",
			enFullName: "Lao People's Dem. Rep.",
			code: 'LA',
			geo: '',
			price: '',
			sort: 'G'
		},
		{
			cnName: '南非',
			enName: 'South Africa',
			enFullName: 'South Africa',
			code: 'ZA',
			geo: '',
			price: '',
			sort: 'G'
		},
		{
			cnName: '安哥拉',
			enName: 'Angola',
			enFullName: 'Angola',
			code: 'AO',
			geo: '',
			price: '',
			sort: 'G'
		},
		{
			cnName: '喀麦隆',
			enName: 'Cameroon',
			enFullName: 'Cameroon',
			code: 'CM',
			geo: '',
			price: '',
			sort: 'G'
		}
	]
};



// WEBPACK FOOTER //
// ./src/constant/ibuCountry.js